import moment from 'moment'

export const format = 'MM/DD/YYYY'

export function isoToDate(str) {
  return moment(str).toDate()
}

export function dateToStr(date, newFormat = format) {
  return moment(date).format(newFormat)
}

export function isoToStr(iso) {
  return dateToStr(isoToDate(iso))
}


// WEBPACK FOOTER //
// ./utilities/date.js